import React, { useState } from 'react';
import { useApi } from '../lib/api';

export default function AnnouncementBanner() {
  const { data, loading, error } = useApi('/api/announcements/active');
  const [closedId, setClosedId] = useState(null);

  if (loading || error) return null;

  const item = data?.data?.[0];
  if (!item) return null;

  const storageKey = `annc_dismissed_${item.id}`;
  if (closedId === item.id || localStorage.getItem(storageKey) === '1') {
    return null;
  }

  const config = {
    info: { label: 'INFORMACJA', bg: 'var(--t-sage-bg)', accent: 'var(--t-sage)' },
    warning: { label: 'UWAGA', bg: 'var(--t-amber-bg)', accent: 'var(--t-amber)' },
    maintenance: { label: 'PRZERWA', bg: 'var(--t-rust-bg)', accent: 'var(--t-rust)' },
  };
  const styleConfig = config[item.level] || config.info;

  const handleClose = () => {
    setClosedId(item.id);
    localStorage.setItem(storageKey, '1');
  };

  const containerStyle = {
    width: '100%',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    borderBottom: '1px solid var(--t-line)',
    boxSizing: 'border-box',
    backgroundColor: styleConfig.bg,
    color: 'var(--t-text)',
  };

  const labelStyle = {
    fontFamily: 'var(--t-mono)',
    letterSpacing: '.16em',
    fontSize: '10px',
    textTransform: 'uppercase',
    color: styleConfig.accent,
    fontWeight: 'bold',
    lineHeight: '1',
  };

  const contentStyle = {
    flex: 1,
    whiteSpace: 'normal',
  };

  const titleStyle = {
    fontWeight: 'bold',
    marginRight: '4px',
  };

  const bodyStyle = {
    color: 'var(--t-text-dim)',
    fontSize: '13px',
  };

  const buttonStyle = {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    color: 'var(--t-text-mute)',
    padding: '0',
    lineHeight: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div style={containerStyle}>
      <span style={labelStyle}>{styleConfig.label}</span>
      <div style={contentStyle}>
        <strong style={titleStyle}>{item.title}</strong>
        {item.body && <span style={bodyStyle}>— {item.body}</span>}
      </div>
      <button style={buttonStyle} onClick={handleClose} aria-label="Zamknij ogłoszenie">
        ×
      </button>
    </div>
  );
}